import React, { useState } from "react";
import { Link } from "react-router-dom";

const SwitchRoleSubmenu = ({ roles, configUserRoles, switchUser }) => {
  const [showSubmenu, setShowSubmenu] = useState(false);

  return (
    <li
      className="nav-top-switch-role"
      onMouseEnter={() => setShowSubmenu(true)}
      onMouseLeave={() => setShowSubmenu(false)}
    >
      <div className="nav-top-dropdown-item">
        <i className="fa fa-users nav-top-icon-blue"></i> Switch Role
      </div>
      <ul className={`nav-top-submenu ${showSubmenu ? "nav-top-visible" : ""}`}>
        {roles.map((role) => (
          <li key={role} className="nav-top-switch-sub-role">
            <Link className="nav-top-role-link" to="#" onClick={() => switchUser(role)}>
              <i className="fa fa-user nav-top-icon-blue"></i> {configUserRoles[role]}
            </Link>
          </li>
        ))}
      </ul>
    </li>
  );
};

export default SwitchRoleSubmenu;
